import { object, string } from 'zod';

import {
  receiverInstructionsSchema,
  senderInstructionsSchema,
  smsTemplateSchema,
} from '../award-configuration/award-configuration.schema';

export const marketingContentFormSchema = object({
  subBrandUuid: string().nullable(),
  senderInstructions: senderInstructionsSchema,
  receiverInstructions: receiverInstructionsSchema,
  smsTemplate: smsTemplateSchema,
}).strict();
